import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
import { useTranslation } from 'react-i18next';
import { GetCoockie } from "../GlobalScript";
export default function FileUpload({ show, handleClose, SendSKUQtyToItemInquiry }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [importDealerModal, setImportDealerModal] = useState(false);
    const [expandDetails, setExpandDetails] = useState(false);
    const [ErrorMsg, setErrorMsg] = useState('');
    const [pop, setPop] = useState(false);
    const MAX_LINES = 200;
    const MAX_FILE_SIZE = 56 * 1024;
    const { t } = useTranslation();

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setErrorMsg('');
    };

    const getExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    }

    const handleUpload = async () => {
        setErrorMsg('');

        if (!selectedFile) {
            setErrorMsg(t('Order.selectFileFirst'));
            return;
        }

        if (getExtension(selectedFile.name) !== 'txt') {
            setErrorMsg(t('Order.selectTxtFile'));
            return;
        }

        const text = await selectedFile.text();
        const lines = text.split(/\r?\n/).filter(line => line.trim() !== "");

        if (lines.length > MAX_LINES) {
            setErrorMsg(`Maximum ${MAX_LINES} items allowed.`);
            return;
        }
        else if (selectedFile.size > MAX_FILE_SIZE) {
            setErrorMsg('The uploaded file cannot exceed 56 KB.');
            return;
        }


        const user = GetCoockie();

        if (!user || !user.dealerID) {
            setErrorMsg('Unable to determine the current dealer.');
            return;
        }

        handlePop();

        const formData = new FormData();

        formData.append(
            'file',
            selectedFile,
            selectedFile.name
        );

        formData.append(
            'dealerID',
            user.dealerID
        );

        try {
            const response = await fetch('kdealer/ImportFile', {
                method: 'POST',
                headers: {
                    Accept: 'application/json'
                },
                body: formData
            });

            if (!response.ok) {
                let errorMessage = 'File upload failed.';

                try {
                    const errorResponse = await response.json();

                    if (errorResponse?.message) {
                        errorMessage = errorResponse.message;
                    }
                } catch {
                    // Keep the default error message.
                }

                throw new Error(errorMessage);
            }

            const importedItems = await response.json();

            const bulkImportKey =
                response.headers.get('X-Bulk-Import-Key');

            const parsedBulkImportKey = Number(bulkImportKey);

            if (!Number.isInteger(parsedBulkImportKey) || parsedBulkImportKey <= 0) {
                throw new Error('Bulk import was saved, but its import key was not returned.');
            }

            console.log(
                'Bulk import created:',
                bulkImportKey
            );

            if (SendSKUQtyToItemInquiry) {
                SendSKUQtyToItemInquiry({
                    bulkImportKey: parsedBulkImportKey,
                    totalItems: importedItems.length,
                    items: importedItems
                });
            }

            setSelectedFile(null);
        } catch (error) {
            console.error('File upload error:', error);

            setErrorMsg(
                error?.message || 'File upload failed!'
            );
        } finally {
            handleClosePop();
        }
    };
    const handleImportModalClose = () => {
        setImportDealerModal(false);
    }

    const handleImportModalShow = () => {
        setImportDealerModal(true);
    }

    const importOrder = () => {
        handleImportModalClose();
    }

    return (
        <>
            <Modal show={show} onHide={handleClose} dialogClassName="dealer-section" centered scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t("Order.importOrder")}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" className="btn-close-sibling" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} className="text-center">
                            <h5>Maximum {MAX_LINES} lines per file</h5>
                        </Col>

                        <Col sm={6} className="mt-3">
                            <input type="file" onChange={handleFileChange} />
                            {selectedFile && (
                                <p className="mt-3 mb-0">
                                    {t("Order.selectedFile")} {selectedFile.name} ({selectedFile.type}, {selectedFile.size}{' '}
                                    bytes)
                                </p>
                            )}
                        </Col>

                        <Col sm={6} className="text-right mt-3">
                            <Button variant="primary" onClick={handleUpload}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                {t("button.upload")}
                            </Button>
                        </Col>

                        {ErrorMsg &&
                            <Col sm={12}>
                                <p className="mt-4 mb-0 red">{ErrorMsg}</p>
                            </Col>
                        }

                        <Col sm={12}>
                            <h4 className="mt-4 text-left">
                                <span className="underline" onClick={() => setExpandDetails(prev => !prev)}>
                                    {t("importInstructions.importOrderSpecifications")}
                                </span>
                            </h4>

                            {expandDetails === true &&
                                <div className="max-height-scrollable-md">
                                    <ol className="text-left mt-3">
                                        <li>
                                            <strong>{t("importInstructions.fileInformation")}</strong>
                                            <ol type="a">
                                                <li>{t("importInstructions.fileMustBeTxt")}</li>
                                                <li>{t("importInstructions.fileSizeLimit")}</li>
                                            </ol>
                                        </li>

                                        <li>
                                            <strong>{t("importInstructions.formatInformation")}</strong>
                                            <ol type="a">
                                                <li>
                                                    {t("importInstructions.recordLengthRequirement")}
                                                </li>
                                                <li>
                                                    {t("importInstructions.fieldLayout")}
                                                    <table border="1" cellPadding="8" cellSpacing="0">
                                                        <thead>
                                                            <tr>
                                                                <th>{t("importInstructions.fieldHeader")}</th>
                                                                <th>{t("importInstructions.positionHeader")}</th>
                                                                <th>{t("importInstructions.lengthHeader")}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>{t("importInstructions.itemNumberField")}</td>
                                                                <td>1-14</td>
                                                                <td>14</td>
                                                            </tr>
                                                            <tr>
                                                                <td>{t("importInstructions.qtyField")}</td>
                                                                <td>15-17</td>
                                                                <td>3</td>
                                                            </tr>
                                                            <tr>
                                                                <td>{t("importInstructions.memoField")}</td>
                                                                <td>18-24</td>
                                                                <td>7</td>
                                                            </tr>
                                                            <tr>
                                                                <td>{t("importInstructions.extraField")}</td>
                                                                <td>25-27</td>
                                                                <td>3</td>
                                                            </tr>
                                                            <tr>
                                                                <td>{t("importInstructions.carriageReturnField")}</td>
                                                                <td colSpan="2">-</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </li>
                                            </ol>
                                        </li>

                                        <li>
                                            <strong>{t("importInstructions.importingProcess")}</strong>
                                            <ol type="a">
                                                <li>{t("importInstructions.browseTxtFile")}</li>
                                                <li>{t("importInstructions.clickImportButton")}</li>
                                                {/*<li>*/}
                                                {/*    {t("importInstructions.viewImportOrderPageInfo")}*/}
                                                {/*</li>*/}
                                                <li>{t("importInstructions.reviewItems")}</li>
                                                <li>{t("importInstructions.addAllItemsButton")}</li>
                                                {/*<li>*/}
                                                {/*    {t("importInstructions.moreItemsCondition")}*/}
                                                {/*    <ol type="1">*/}
                                                {/*        <li>*/}
                                                {/*            {t("importInstructions.continueImportLink")}*/}
                                                {/*        </li>*/}
                                                {/*        <li>{t("importInstructions.repeatProcess")}</li>*/}
                                                {/*    </ol>*/}
                                                {/*</li>*/}
                                                <li>{t("importInstructions.orderImported")}</li>
                                                <li>{t("importInstructions.verifyBeforeSubmit")}</li>
                                            </ol>
                                        </li>
                                    </ol>
                                </div>
                            }
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>
        </>
    );
}

